import Vue from 'vue';
import Favorites from "../components/Favorites/Favorites";

namespace NHW.controllers.favorites {
	function initializeFavorites() {
		new Vue({
			render: (h) => h(Favorites)
		}).$mount('#favoritesApp');
	}

	function setupPrint(){
		//let printButton = $('.js-print');
	}

	export function init() {
		if (document.querySelector('.js-component')) {
			initializeFavorites();
		}
		//setupPrint();
	}
}

NHW.controllers.favorites.init();
